<template>
  <div class="border" style="display: flex;align-items: center">
    <el-select v-model="searchListData.type" @change="change">
      <el-option
        v-for="items in typeOption"
        :label="items.label"
        :key="items.value"
        :value="items.value"
      ></el-option>
    </el-select>
    <el-form-item label="状态" v-show="searchListData.type==1">
      <el-select v-model="searchListData.typeValue" clearable>
        <el-option
          v-for="items in typeValueOption"
          :label="items.label"
          :key="items.value"
          :value="items.value"
        ></el-option>
      </el-select>
    </el-form-item>

    <el-form-item v-if="searchListData.type==5" label="为">
<!--      <el-select v-model="searchListData.proTypeValue" @change="changeProduct" multiple placeholder="请选择">-->
<!--        <el-option-->
<!--                v-for="item in productList"-->
<!--                :key="item.value"-->
<!--                :label="item.label"-->
<!--                :value="item.value"-->
<!--        ></el-option>-->
<!--      </el-select>-->
      <div style="display: flex">
        <div>
          <el-select
                  v-model="searchListData.conditionsProductType"
                  @change="changeProductClass"
                  @remove-tag="removeTag"
                  multiple
                  placeholder="请选择"
          >
            <el-option
                    v-for="item in classList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="task">
          <el-select
                  collapse-tags
                  multiple
                  v-model="searchListData.conditionsValue"
                  placeholder="请选择"
                  @change="selectAll"
                  clearable
          >
            <el-option
                    v-for="item in searchListData.productList"
                    :label="item.value"
                    :key="item.label"
                    :value="item.label"
            />
          </el-select>
        </div>
      </div>


    </el-form-item>

    <el-form-item v-show="searchListData.type==3 || searchListData.type ==6 || searchListData.type == 7" label="达到">
      <el-form-item prop="sort">
        <el-input-number v-model="searchListData.typeValue" controls-position="right" ></el-input-number>美元
      </el-form-item>
    </el-form-item>

    <el-form-item v-show="searchListData.type==4" label="达到">
      <el-form-item prop="sort">
        <el-input-number v-model="searchListData.typeValue" controls-position="right" ></el-input-number>手
      </el-form-item>
    </el-form-item>

    <div @click="delist(searchListData.index,searchListData.id)" style="cursor:pointer;    position: absolute;
    right: 34px;">
      <i class="el-icon-delete" style="font-size:24px;"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: ["searchListData"],
  data() {
    return {
      productList:[],
      oldProductList: [],
      oldOptions: [],
      classList: [
        {
          value: "2",
          label: "外汇"
        },
        {
          value: "4",
          label: "商品"
        },
        {
          value: "5",
          label: "指数"
        },
          {
              value: "6",
              label: "虚拟币"
          },
        {
          value: "7",
          label: "股票"
        }
      ],
      typeOption: [
        // {
        //   value: "1",
        //   label: "开户成功"
        // },
        {
          value: "2",
          label: "登录成功"
        },
        {
          value: "3",
          label: "净入金"
        },
        {
          value: "4",
          label: "交易手数"
        },
        {
          value: "5",
          label: "交易产品"
        },
        {
          value: "6",
          label: "平仓总盈亏"
        },
        /*{
          value: "7",
          label: "账户总净值"
        }*/
        ],
         typeValueOption: [
          {
            value: 1,
            label: "为真"
          },
          {
            value: 2,
            label: "为假"
          }
        ]
    };
  },
  methods: {
    //通過值查找对应的 value方法
    findKey(obj, value, compare = (a, b) => a === b) {
      return Object.keys(obj).find(k => compare(obj[k], value));
    },
    //下拉列表选框
    change(key) {
      // this.searchListData.typeValue = '';
      this.searchListData.type = key;
    },
    changeProduct(key){
        this.searchListData.typeValue = key.join(',')
    },
    changeProductClass(val) {
     if(this.oldOptions.includes('allSelect')){
        this.getProductList(val,"all");
     }else{
      this.getProductList(val);
     }

    },
    getProductList(val,type) {
      let _this = this;
      const url =
              val != null && val != ""
                      ? "/task/activity/tradeConfig/" + val
                      : "/task/activity/tradeConfig/0";
      _this.searchListData.productList = [];
      this.$http.get(url).then(res => {
        if (res.data.code == 0) {
          if (res.data.data == "") {
            this.searchListData.productList = [];
            this.searchListData.conditionsValue = [];
          } else {
            Object.keys(res.data.data).forEach(function(key) {
              _this.searchListData.productList.push(
                      Object.assign({}, { value: res.data.data[key], label: key })
              );
            });

            if(type == "all"){
              let arr = []
               for (var i in _this.searchListData.productList) {
                 arr.push(_this.searchListData.productList[i].label);
              }
              _this.searchListData.conditionsValue = arr
              const allSelect = {
              value: "全选",
              label: "allSelect"
            };
            _this.searchListData.productList.unshift(allSelect);

            }else{
              const allSelect = {
              value: "全选",
              label: "allSelect"
            };
            _this.searchListData.productList.unshift(allSelect);
            }
            if (
                    _this.oldProductList.length < _this.searchListData.productList.length
            ) {
              _this.oldProductList = _this.searchListData.productList;
            } else {
              let productListArr = [];
              for (var i in _this.searchListData.productList) {
                productListArr.push(_this.searchListData.productList[i].label);
              }
              _this.searchListData.conditionsValue = this.getArrEqual(
                      productListArr,
                      _this.searchListData.conditionsValue
              );
            }
          }
        }
      });
    },
    delist(index,id){
      this.$confirm('是否删除条件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //删除条件
        if(id!=null && id !=='' && id != undefined) {
          const url = "/activity/luckyDraw/conditionDelete?id=" + id;
          this.$http.delete(url).then(({ data: res }) => {
            if (res.code != 0) {
              return this.$message.error(res.msg);
            } else {
              this.$message({
                message: "删除条件成功！",
                type: "success"
              });
              let idIndex = {
                id:id,
                index:index
              }
              this.$emit('deleteListData',idIndex);
            }
          });
        }else{
          this.$message({
            message: "删除条件成功！",
            type: "success"
          });
          let idIndex = {
            id:id,
            index:index
          }
          this.$emit('deleteListData',idIndex);
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    removeTag(val) {},
    getArrEqual(arr1, arr2) {
      let newArr = [];
      for (let i = 0; i < arr2.length; i++) {
        for (let j = 0; j < arr1.length; j++) {
          if (arr1[j] === arr2[i]) {
            newArr.push(arr1[j]);
          }
        }
      }
      return newArr;
    },
    selectAll(valArr) {
      const allIdArr = [];
      // 保存所有选项的id
      for (const argumentId of this.searchListData.productList) {
        allIdArr.push(argumentId.label);
      }
      const oldVal = this.oldOptions.length > 0 ? this.oldOptions : [];
        // oldVal.push('allSelect')
      // 当前选中的有'全选'
      if (valArr.includes("allSelect")) {
        this.searchListData.conditionsValue = allIdArr;
      }
      // 旧数据包含'全选'，当前选中数据不包含全选
      if (oldVal.includes("allSelect") && !valArr.includes("allSelect")) {
        this.searchListData.conditionsValue = [];
      }
      // if(oldVal.length == 0 && !valArr.includes("allSelect")){
      //    this.searchListData.conditionsValue = [];
      // }else{}
      // 旧数据包含'全选'，当前选中数据包含全选
      if (oldVal.includes("allSelect") && valArr.includes("allSelect")) {
        const index = valArr.indexOf("allSelect");
        valArr.splice(index, 1); // 排除全选选项
        this.searchListData.conditionsValue = valArr;
      }
      // 旧数据不包含'全选'，当前选中数据不包含'全选'
      if (!oldVal.includes("allSelect") && !valArr.includes("allSelect")) {
        // 除了全选外 其他全部选中时
        if (valArr.length === allIdArr.length - 1) {
          this.searchListData.conditionsValue = ["allSelect"].concat(valArr);
        }
      }
      // 数据发生变化时保存数据，作为下次对比的旧数据
      this.oldOptions = this.searchListData.conditionsValue;
    },
  },
  mounted() {
  }
};
</script>

<style>
</style>
